const preloadImages = images =>
  images.forEach(image => {
    const preloadImage = new Image()
    preloadImage.src = image
  })

export default preloadImages
